import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["list", "template"];

  add() {
    this.sequence = (this.sequence || Date.now()) + 1;
    this.listTarget.insertAdjacentHTML("beforeend", this.templateTarget.innerHTML.replaceAll("NEW_RECORD", this.sequence));
  }

  remove(event) {
    const row = event.target.closest("[data-nested-row]");
    if (row.dataset.newRecord === "true") row.remove();
    else {
      row.querySelector("input[name$='[_destroy]']").value = "1";
      row.hidden = true;
    }
  }
}
